import {ProgressBar} from '@primer/react'
import {SkeletonText} from '@primer/react/experimental'
import type {SidebarLanguagesProps} from '../types'
import {SidebarSection} from './SidebarSection'
import {SidebarLink} from './SidebarLink'
import styles from './SidebarLanguages.module.css'

/** Renders the language breakdown bar and list for the repository sidebar. */
export function SidebarLanguages({languages, isFork, ownerLogin, repoName}: SidebarLanguagesProps) {
  if (languages.length === 0) return null

  return (
    <SidebarSection title="Languages">
      <div className="mb-2">
        <ProgressBar aria-label="Repository language breakdown">
          {languages.map(lang => (
            <ProgressBar.Item
              aria-label={`${lang.name || 'Other'}: ${lang.percentage}%`}
              key={`bar-${lang.name || 'Other'}`}
              progress={lang.percentage}
              style={{backgroundColor: lang.color}}
            />
          ))}
        </ProgressBar>
      </div>
      <ul className={styles.languageList}>
        {languages.map(lang => {
          const displayName = lang.name || 'Other'
          const isOther = !lang.name

          return (
            <li key={`lang-${displayName}`} className={styles.languageListItem}>
              {isFork || isOther ? (
                <span className={styles.languageItem}>
                  <span className={styles.languageDot} style={{backgroundColor: lang.color}} />
                  <span className={styles.languageName} itemProp="keywords">
                    {displayName}
                  </span>
                  <span>{lang.percentage}%</span>
                </span>
              ) : (
                <SidebarLink
                  to={`/${ownerLogin}/${repoName}/search?l=${encodeURIComponent(lang.searchAlias ?? lang.name)}`}
                  className={styles.languageLink}
                  analyticsLabel="section:languages"
                >
                  <span className={styles.languageDot} style={{backgroundColor: lang.color}} />
                  <span className={styles.languageName} itemProp="keywords">
                    {displayName}
                  </span>
                  <span>{lang.percentage}%</span>
                </SidebarLink>
              )}
            </li>
          )
        })}
      </ul>
    </SidebarSection>
  )
}

export function SidebarLanguagesSkeleton() {
  return (
    <SidebarSection title="Languages">
      <SkeletonText />
    </SidebarSection>
  )
}
